import React, { useEffect, useState } from "react";
import { Button, Card, ConfigProvider, message, Spin } from "antd";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./privacyPolicy.css";
import { callApi } from "../../api/apiCaller";
import { routes } from "../../api/routes";
import Loader from "../../components/loader/loader";

const PrivacyPolicy = () => {
  const [content, setContent] = useState("");
  const [policyId, setPolicyId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const fetchPrivacy = () => {
    callApi(
      "GET",
      routes.getPrivacyPolicy,
      null,
      setLoading,
      (res) => {
        if (res.status === 200) {
          const policies = res.data?.data || [];
          if (policies.length > 0) {
            const policy = policies[0];
            setContent(policy.data || "");
            setPolicyId(policy._id);
          } else {
            message.warning("No privacy policy found");
          }
        }
      },
      (error) => {
        message.error("Failed to load Privacy Policy");
      }
    );
  };

  const savePrivacy = () => {
    if (!content.trim()) {
      message.warning("Please enter privacy policy content");
      return;
    }

    if (!policyId) {
      message.error("Policy ID not found");
      return;
    }

    const body = { data: content };

    callApi(
      "PATCH",
      `${routes.updatePrivacyPolicy}/${policyId}`,
      body,
      setSaving,
      (res) => {
        if (res.status === 200) {
          message.success("Privacy Policy updated successfully");
          fetchPrivacy();
        }
      },
      (error) => {
        message.error("Failed to update Privacy Policy");
      }
    );
  };

  useEffect(() => {
    fetchPrivacy();
  }, []);

  return (
    <ConfigProvider theme={{ token: { colorPrimary: "#FF66B2" } }}>
      <div className="privacy-page-container">
        <Loader loading={loading} />
        <Card
          className="privacy-card"
          title={<span className="privacy-title">Privacy Policy</span>}
          extra={
            <Button
              type="primary"
              onClick={savePrivacy}
              loading={saving}
              disabled={loading || !policyId}
            >
              Save Changes
            </Button>
          }
        >
          {loading ? (
            <div className="privacy-loader">
              <Spin />
            </div>
          ) : (
            <ReactQuill
              theme="snow"
              value={content}
              onChange={setContent}
              className="privacy-editor"
              placeholder="Enter privacy policy content..."
            />
          )}
        </Card>
      </div>
    </ConfigProvider>
  );
};

export default PrivacyPolicy;
